module.exports = __webpack_public_path__ + "img/coi-logo.8d863217.png";